import { useEffect, useMemo, useState } from 'react';
function subQueryToMediaQueryString(subQuery) {
    const queryParts = Object.entries(subQuery).map(([key, value]) => {
        let cssKey = '';
        switch (key) {
            case 'maxWidth':
                cssKey = 'max-width';
                break;
            case 'minWidth':
                cssKey = 'min-width';
                break;
            case 'maxHeight':
                cssKey = 'max-height';
                break;
            case 'minHeight':
                cssKey = 'min-height';
                break;
            case 'orientation':
                cssKey = 'orientation';
                break;
            default:
                return '';
        }
        if (cssKey === 'orientation') {
            return `(${cssKey}: ${value})`;
        }
        else {
            const unit = typeof value === 'number' ? 'px' : '';
            return `(${cssKey}: ${value}${unit})`;
        }
    });
    return queryParts.filter(Boolean).join(' and ');
}
export default function useMediaQuery(query) {
    const [matches, setMatches] = useState([]);
    const queries = useMemo(() => {
        const subQueries = Array.isArray(query) ? query : [query];
        return subQueries.map(subQueryToMediaQueryString);
    }, [query]);
    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return;
        }
        const mediaQueryLists = queries.map((q) => window.matchMedia(q));
        const updateMatches = () => {
            setMatches(mediaQueryLists.map((mql) => mql.matches));
        };
        updateMatches();
        const handlers = mediaQueryLists.map((mql, index) => {
            const handler = (event) => {
                setMatches((prev) => {
                    const updated = [...prev];
                    updated[index] = event.matches;
                    return updated;
                });
            };
            mql.addEventListener('change', handler);
            return () => mql.removeEventListener('change', handler);
        });
        return () => {
            handlers.forEach((cleanup) => cleanup());
        };
    }, [queries]);
    return matches;
}
